import React from 'react';
import JiraErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

type Props = {
	children: React.ReactNode;
};
export const ErrorBoundary = ({ children }: Props) => (
	<JiraErrorBoundary
		onError={(_, error) => {
			fireErrorAnalytics({
				meta: { id: 'cross-join-nudges-your-work-error-boundary' },
				error,
			});
		}}
	>
		{children}
	</JiraErrorBoundary>
);
